import { ComplianceAlertStatsData } from '@/redux/models';
import { RiskKeys } from '@/config';
import { BehaviorTx } from '@/api';

export const alertsDemoData: ComplianceAlertStatsData = {
  stats: {
    byRisk: {
      low: 7,
      medium: 6,
      high: 9,
      severe: 2,
      na: 0,
    },
    byStatus: {
      new: 7,
      pending: 0,
      confirmed: 14,
      rejected: 3,
    },
    totalByRisk: 24,
    totalByStatus: 24,
  },
  alerts: {
    entries: [
      {
        key: '1',
        uid: 'demo-alert-1',
        id: '1',
        user: 'User_3',
        address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
        causingTxHash:
          '0xda7b34e91a5c8f20b39d1e7a8b9c0a1f2e3d4c5b6a7f8e9d0c1b2a3f4e5d6c7b',
        direction: 'outcome',
        risk: 'low',
        riskyFunds: 8491.51,
        entityCategory: [RiskKeys.WALLET],
        state: 'rejected',
        date: '27.11.2025 20:40',
        customer: [
          {
            id: '1',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '101',
            createdDate: '2025-11-27T20:40:15.000Z',
            updatedDate: '2025-11-27T20:40:16.000Z',
            confirmedDate: '2025-11-27T20:35:10.000Z',
            nextUpdateTs: '2025-11-27T20:41:15.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c',
            direction: 'outcome',
            address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
            flow: 'fast',
            memo: '',
            level: 'low',
          },
          {
            id: '102',
            createdDate: '2025-11-27T20:38:22.000Z',
            updatedDate: '2025-11-27T20:38:23.000Z',
            confirmedDate: '2025-11-27T20:33:18.000Z',
            nextUpdateTs: '2025-11-27T20:39:22.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x9b3e4c6d8f2a5b7c9e1d3f5a7b9c1e3d5f7a9b1c3e5d7f9a1b3c5e7d9f1a3b5c',
            direction: 'outcome',
            address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
            flow: 'normal',
            memo: '',
            level: 'low',
          },
        ] as BehaviorTx[],
      },
      {
        key: '2',
        uid: 'demo-alert-2',
        id: '2',
        user: 'User_3',
        address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
        causingTxHash:
          '0xda7b34e91a5c8f20b39d1e7a8b9c0a1f2e3d4c5b6a7f8e9d0c1b2a3f4e5d6c7b',
        direction: 'outcome',
        risk: 'low',
        riskyFunds: 2977.52,
        entityCategory: [RiskKeys.ATM],
        state: 'new',
        date: '27.11.2025 20:40',
        customer: [
          {
            id: '1',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '201',
            createdDate: '2025-11-27T20:40:10.000Z',
            updatedDate: '2025-11-27T20:40:11.000Z',
            confirmedDate: '2025-11-27T20:35:05.000Z',
            nextUpdateTs: '2025-11-27T20:41:10.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x2c4d6e8f0a2b4c6e8f0a2b4c6e8f0a2b4c6e8f0a2b4c6e8f0a2b4c6e8f0a2b',
            direction: 'outcome',
            address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
            flow: 'fast',
            memo: '',
            level: 'low',
          },
        ] as BehaviorTx[],
      },
      {
        key: '3',
        uid: 'demo-alert-3',
        id: '3',
        user: 'User_3',
        address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
        causingTxHash:
          '0xda7b34e91a5c8f20b39d1e7a8b9c0a1f2e3d4c5b6a7f8e9d0c1b2a3f4e5d6c7b',
        direction: 'outcome',
        risk: 'severe',
        riskyFunds: 6902.47,
        entityCategory: [RiskKeys.MIXER],
        state: 'new',
        date: '27.11.2025 20:40',
        customer: [
          {
            id: '1',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '301',
            createdDate: '2025-11-27T20:40:05.000Z',
            updatedDate: '2025-11-27T20:40:06.000Z',
            confirmedDate: '2025-11-27T20:35:00.000Z',
            nextUpdateTs: '2025-11-27T20:41:05.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x3d5e7f9a1b3c5e7f9a1b3c5e7f9a1b3c5e7f9a1b3c5e7f9a1b3c5e7f9a1b',
            direction: 'outcome',
            address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
            flow: 'fast',
            memo: '',
            level: 'severe',
          },
          {
            id: '302',
            createdDate: '2025-11-27T20:39:58.000Z',
            updatedDate: '2025-11-27T20:39:59.000Z',
            confirmedDate: '2025-11-27T20:34:55.000Z',
            nextUpdateTs: '2025-11-27T20:40:58.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x4e6f8a0b2c4d6e8f0a2b4c6d8e0f2a4b6c8d0e2f4a6b8c0d2e4f6a8b0c2d',
            direction: 'outcome',
            address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
            flow: 'normal',
            memo: '',
            level: 'severe',
          },
          {
            id: '303',
            createdDate: '2025-11-27T20:39:45.000Z',
            updatedDate: '2025-11-27T20:39:46.000Z',
            confirmedDate: '2025-11-27T20:34:42.000Z',
            nextUpdateTs: '2025-11-27T20:40:45.000Z',
            blockchain: 'polygon',
            asset: null,
            hash: '0x5f7a9b1d3e5f7a9b1d3e5f7a9b1d3e5f7a9b1d3e5f7a9b1d3e5f7a9b1d3e5f',
            direction: 'outcome',
            address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
            flow: 'slow',
            memo: '',
            level: 'severe',
          },
        ] as BehaviorTx[],
      },
      {
        key: '4',
        uid: 'demo-alert-4',
        id: '4',
        user: 'User_3',
        address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
        causingTxHash:
          '0xda7b34e91a5c8f20b39d1e7a8b9c0a1f2e3d4c5b6a7f8e9d0c1b2a3f4e5d6c7b',
        direction: 'outcome',
        risk: 'medium',
        riskyFunds: 4887.58,
        entityCategory: [RiskKeys.LIQUIDITY_POOLS],
        state: 'confirmed',
        date: '27.11.2025 20:40',
        customer: [
          {
            id: '1',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '401',
            createdDate: '2025-11-27T20:40:00.000Z',
            updatedDate: '2025-11-27T20:40:01.000Z',
            confirmedDate: '2025-11-27T20:34:55.000Z',
            nextUpdateTs: '2025-11-27T20:41:00.000Z',
            blockchain: 'polygon',
            asset: null,
            hash: '0x6a8c0d2e4f6a8c0d2e4f6a8c0d2e4f6a8c0d2e4f6a8c0d2e4f6a8c0d2e4f',
            direction: 'outcome',
            address: '0x4b7e8a2d1c3f5b9a7e2d4c8f1a3b5c7e8a2d1c3f',
            flow: 'normal',
            memo: '',
            level: 'medium',
          },
        ] as BehaviorTx[],
      },
      {
        key: '5',
        uid: 'demo-alert-5',
        id: '5',
        user: 'User_5',
        address: '1J7Lz8A9BcN2dV4fG7hJk9Lp3Qr5sT6uVw8xYz2aB',
        causingTxHash:
          '7a1b9c0d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c',
        direction: 'income',
        risk: 'high',
        riskyFunds: 824,
        entityCategory: [RiskKeys.MIXER],
        state: 'confirmed',
        date: '23.10.2025 11:31',
        customer: [
          {
            id: '2',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '501',
            createdDate: '2025-10-23T11:31:20.000Z',
            updatedDate: '2025-10-23T11:31:21.000Z',
            confirmedDate: '2025-10-23T11:26:15.000Z',
            nextUpdateTs: '2025-10-23T11:32:20.000Z',
            blockchain: 'btc',
            asset: null,
            hash: 'a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b',
            direction: 'income',
            address: '1J7Lz8A9BcN2dV4fG7hJk9Lp3Qr5sT6uVw8xYz2aB',
            flow: 'normal',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '6',
        uid: 'demo-alert-6',
        id: '6',
        user: 'User_2',
        address: '0x9a8b7c6d5e4f3a2b1c0d9e8f7a6b5c4d3e2f1a0b',
        causingTxHash:
          '0xfa8e29d1c3b5a7f9e2d4c8b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5',
        direction: 'outcome',
        risk: 'severe',
        riskyFunds: 766.12,
        entityCategory: [RiskKeys.SCAM],
        state: 'rejected',
        date: '11.09.2025 17:52',
        customer: [
          {
            id: '3',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '601',
            createdDate: '2025-09-11T17:52:30.000Z',
            updatedDate: '2025-09-11T17:52:31.000Z',
            confirmedDate: '2025-09-11T17:47:25.000Z',
            nextUpdateTs: '2025-09-11T17:53:30.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x7b9c1d3e5f7a9b1c3d5e7f9a1b3c5d7e9f1a3b5c7d9e1f3a5b7c9d1e3f5a7b9c',
            direction: 'outcome',
            address: '0x9a8b7c6d5e4f3a2b1c0d9e8f7a6b5c4d3e2f1a0b',
            flow: 'fast',
            memo: '',
            level: 'severe',
          },
          {
            id: '602',
            createdDate: '2025-09-11T17:52:15.000Z',
            updatedDate: '2025-09-11T17:52:16.000Z',
            confirmedDate: '2025-09-11T17:47:10.000Z',
            nextUpdateTs: '2025-09-11T17:53:15.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x8c0d2e4f6a8c0d2e4f6a8c0d2e4f6a8c0d2e4f6a8c0d2e4f6a8c0d2e4f6a8c',
            direction: 'outcome',
            address: '0x9a8b7c6d5e4f3a2b1c0d9e8f7a6b5c4d3e2f1a0b',
            flow: 'normal',
            memo: '',
            level: 'severe',
          },
        ] as BehaviorTx[],
      },
      {
        key: '7',
        uid: 'demo-alert-7',
        id: '7',
        user: 'User_2',
        address: '0x9a8b7c6d5e4f3a2b1c0d9e8f7a6b5c4d3e2f1a0b',
        causingTxHash:
          '0xfa8e29d1c3b5a7f9e2d4c8b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5',
        direction: 'outcome',
        risk: 'medium',
        riskyFunds: 797.5,
        entityCategory: [RiskKeys.GAMBLING],
        state: 'confirmed',
        date: '11.09.2025 17:52',
        customer: [
          {
            id: '3',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '701',
            createdDate: '2025-09-11T17:52:00.000Z',
            updatedDate: '2025-09-11T17:52:01.000Z',
            confirmedDate: '2025-09-11T17:46:55.000Z',
            nextUpdateTs: '2025-09-11T17:53:00.000Z',
            blockchain: 'polygon',
            asset: null,
            hash: '0x9d1e3f5a7b9c1d3e5f7a9b1c3d5e7f9a1b3c5d7e9f1a3b5c7d9e1f3a5b7c9d1e',
            direction: 'outcome',
            address: '0x9a8b7c6d5e4f3a2b1c0d9e8f7a6b5c4d3e2f1a0b',
            flow: 'slow',
            memo: '',
            level: 'medium',
          },
        ] as BehaviorTx[],
      },
      {
        key: '8',
        uid: 'demo-alert-8',
        id: '8',
        user: 'User_5',
        address: 'TDFjx8Z94tsy6ZxLzSjQ7V6d5Y2TGkPQMr',
        causingTxHash:
          'a9c0b1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0',
        direction: 'outcome',
        risk: 'medium',
        riskyFunds: 608.3,
        entityCategory: [RiskKeys.DARK_MARKET],
        state: 'new',
        date: '09.09.2025 09:27',
        customer: [
          {
            id: '4',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '801',
            createdDate: '2025-09-09T09:27:45.000Z',
            updatedDate: '2025-09-09T09:27:46.000Z',
            confirmedDate: '2025-09-09T09:22:40.000Z',
            nextUpdateTs: '2025-09-09T09:28:45.000Z',
            blockchain: 'trx',
            asset: null,
            hash: 'TDFjx8Z94tsy6ZxLzSjQ7V6d5Y2TGkPQMr1234567890abcdef',
            direction: 'outcome',
            address: 'TDFjx8Z94tsy6ZxLzSjQ7V6d5Y2TGkPQMr',
            flow: 'fast',
            memo: '',
            level: 'medium',
          },
        ] as BehaviorTx[],
      },
      {
        key: '9',
        uid: 'demo-alert-9',
        id: '9',
        user: 'User_1',
        address: '1AcBdCeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkL',
        causingTxHash:
          'b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d',
        direction: 'outcome',
        risk: 'low',
        riskyFunds: 397.5,
        entityCategory: [RiskKeys.GAMBLING],
        state: 'confirmed',
        date: '25.08.2025 07:15',
        customer: [
          {
            id: '5',
            name: 'User_1',
            identifier: 'User_1',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '901',
            createdDate: '2025-08-25T07:15:20.000Z',
            updatedDate: '2025-08-25T07:15:21.000Z',
            confirmedDate: '2025-08-25T07:10:15.000Z',
            nextUpdateTs: '2025-08-25T07:16:20.000Z',
            blockchain: 'btc',
            asset: null,
            hash: 'b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c',
            direction: 'outcome',
            address: '1AcBdCeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkL',
            flow: 'normal',
            memo: '',
            level: 'low',
          },
        ] as BehaviorTx[],
      },
      {
        key: '10',
        uid: 'demo-alert-10',
        id: '10',
        user: 'User_3',
        address: '0x2f4e6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a',
        causingTxHash:
          '0x3c6a9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c',
        direction: 'income',
        risk: 'high',
        riskyFunds: 673.6,
        entityCategory: [RiskKeys.CHILD_EXPLOITATION],
        state: 'new',
        date: '01.08.2025 03:05',
        customer: [
          {
            id: '6',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1001',
            createdDate: '2025-08-01T03:05:10.000Z',
            updatedDate: '2025-08-01T03:05:11.000Z',
            confirmedDate: '2025-08-01T03:00:05.000Z',
            nextUpdateTs: '2025-08-01T03:06:10.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x0e2f4a6c8e0a2c4e6a8c0e2f4a6c8e0a2c4e6a8c0e2f4a6c8e0a2c4e6a8c0e2f',
            direction: 'income',
            address: '0x2f4e6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a',
            flow: 'fast',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '11',
        uid: 'demo-alert-11',
        id: '11',
        user: 'User_3',
        address: '0x2f4e6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a',
        causingTxHash:
          '0x3c6a9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c9b1d2e5f8a0c',
        direction: 'income',
        risk: 'high',
        riskyFunds: 25048,
        entityCategory: [RiskKeys.OTHER],
        state: 'new',
        date: '01.08.2025 03:05',
        customer: [
          {
            id: '6',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1101',
            createdDate: '2025-08-01T03:05:00.000Z',
            updatedDate: '2025-08-01T03:05:01.000Z',
            confirmedDate: '2025-08-01T02:59:55.000Z',
            nextUpdateTs: '2025-08-01T03:06:00.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x1f3a5c7e9a1c3e5a7c9e1a3c5e7a9c1e3a5c7e9a1c3e5a7c9e1a3c5e7a9c1e',
            direction: 'income',
            address: '0x2f4e6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a',
            flow: 'normal',
            memo: '',
            level: 'high',
          },
          {
            id: '1102',
            createdDate: '2025-08-01T03:04:45.000Z',
            updatedDate: '2025-08-01T03:04:46.000Z',
            confirmedDate: '2025-08-01T02:59:40.000Z',
            nextUpdateTs: '2025-08-01T03:05:45.000Z',
            blockchain: 'polygon',
            asset: null,
            hash: '0x2a4c6e8f0a2c4e6f8a0c2e4f6a8c0e2f4a6c8e0a2c4f6a8c0e2f4a6c8e0a2c4',
            direction: 'income',
            address: '0x2f4e6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a',
            flow: 'fast',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '12',
        uid: 'demo-alert-12',
        id: '12',
        user: 'User_2',
        address: '1Q5R7sT9uVwXyZa1bCdEfGhJkLmNoPqRsTuVwXyZ',
        causingTxHash:
          'c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e',
        direction: 'income',
        risk: 'high',
        riskyFunds: 496.56,
        entityCategory: [RiskKeys.RANSOM],
        state: 'new',
        date: '28.06.2025 21:12',
        customer: [
          {
            id: '7',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1201',
            createdDate: '2025-06-28T21:12:30.000Z',
            updatedDate: '2025-06-28T21:12:31.000Z',
            confirmedDate: '2025-06-28T21:07:25.000Z',
            nextUpdateTs: '2025-06-28T21:13:30.000Z',
            blockchain: 'btc',
            asset: null,
            hash: 'c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d',
            direction: 'income',
            address: '1Q5R7sT9uVwXyZa1bCdEfGhJkLmNoPqRsTuVwXyZ',
            flow: 'normal',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '13',
        uid: 'demo-alert-13',
        id: '13',
        user: 'User_5',
        address: '0x5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d',
        causingTxHash:
          '0xef8d2c4b6a0e9d1c3b5a7f9e2d4c8b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c',
        direction: 'outcome',
        risk: 'medium',
        riskyFunds: 523.7,
        entityCategory: [RiskKeys.EXCHANGE_FRAUDULENT],
        state: 'confirmed',
        date: '26.06.2025 04:49',
        customer: [
          {
            id: '8',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1301',
            createdDate: '2025-06-26T04:49:15.000Z',
            updatedDate: '2025-06-26T04:49:16.000Z',
            confirmedDate: '2025-06-26T04:44:10.000Z',
            nextUpdateTs: '2025-06-26T04:50:15.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x3b5d7f9a1c3e5a7c9e1a3c5e7a9c1e3a5c7e9a1c3e5a7c9e1a3c5e7a9c1e3a5',
            direction: 'outcome',
            address: '0x5e7d9c2b1a3f5e7d9c2b1a3f5e7d9c2b1a3f5e7d',
            flow: 'slow',
            memo: '',
            level: 'medium',
          },
        ] as BehaviorTx[],
      },
      {
        key: '14',
        uid: 'demo-alert-14',
        id: '14',
        user: 'User_4',
        address: 'TZg9R4Lm6WxE7NkYSrA1B2cD3EFgHiJkL',
        causingTxHash:
          'd2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e2',
        direction: 'outcome',
        risk: 'medium',
        riskyFunds: 752.93,
        entityCategory: [RiskKeys.ILLEGAL_SERVICE],
        state: 'confirmed',
        date: '23.06.2025 18:29',
        customer: [
          {
            id: '9',
            name: 'User_4',
            identifier: 'User_4',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1401',
            createdDate: '2025-06-23T18:29:45.000Z',
            updatedDate: '2025-06-23T18:29:46.000Z',
            confirmedDate: '2025-06-23T18:24:40.000Z',
            nextUpdateTs: '2025-06-23T18:30:45.000Z',
            blockchain: 'trx',
            asset: null,
            hash: 'TZg9R4Lm6WxE7NkYSrA1B2cD3EFgHiJkL9876543210fedcba',
            direction: 'outcome',
            address: 'TZg9R4Lm6WxE7NkYSrA1B2cD3EFgHiJkL',
            flow: 'fast',
            memo: '',
            level: 'medium',
          },
        ] as BehaviorTx[],
      },
      {
        key: '15',
        uid: 'demo-alert-15',
        id: '15',
        user: 'User_4',
        address: 'TZg9R4Lm6WxE7NkYSrA1B2cD3EFgHiJkL',
        causingTxHash:
          'd2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e2',
        direction: 'outcome',
        risk: 'low',
        riskyFunds: 442.2,
        entityCategory: [RiskKeys.ENFORCEMENT_ACTION],
        state: 'confirmed',
        date: '23.06.2025 18:29',
        customer: [
          {
            id: '9',
            name: 'User_4',
            identifier: 'User_4',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1501',
            createdDate: '2025-06-23T18:29:30.000Z',
            updatedDate: '2025-06-23T18:29:31.000Z',
            confirmedDate: '2025-06-23T18:24:25.000Z',
            nextUpdateTs: '2025-06-23T18:30:30.000Z',
            blockchain: 'trx',
            asset: null,
            hash: 'TZg9R4Lm6WxE7NkYSrA1B2cD3EFgHiJkLabcdef1234567890',
            direction: 'outcome',
            address: 'TZg9R4Lm6WxE7NkYSrA1B2cD3EFgHiJkL',
            flow: 'normal',
            memo: '',
            level: 'low',
          },
        ] as BehaviorTx[],
      },
      {
        key: '16',
        uid: 'demo-alert-16',
        id: '16',
        user: 'User_2',
        address: '1Lp3Qr5sT6uVwXyZaBcDeFgHiJkLmNoPqRsTu',
        causingTxHash:
          'e3f4a5b6c7d8e9f0a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9c0d1e2f',
        direction: 'income',
        risk: 'high',
        riskyFunds: 539.1,
        entityCategory: [RiskKeys.STOLEN_COINS],
        state: 'confirmed',
        date: '21.06.2025 10:20',
        customer: [
          {
            id: '10',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1601',
            createdDate: '2025-06-21T10:20:20.000Z',
            updatedDate: '2025-06-21T10:20:21.000Z',
            confirmedDate: '2025-06-21T10:15:15.000Z',
            nextUpdateTs: '2025-06-21T10:21:20.000Z',
            blockchain: 'btc',
            asset: null,
            hash: 'd4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e',
            direction: 'income',
            address: '1Lp3Qr5sT6uVwXyZaBcDeFgHiJkLmNoPqRsTu',
            flow: 'fast',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '17',
        uid: 'demo-alert-17',
        id: '17',
        user: 'User_5',
        address: '1gHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmNoPqR',
        causingTxHash:
          '1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b',
        direction: 'outcome',
        risk: 'high',
        riskyFunds: 599.1,
        entityCategory: [RiskKeys.RANSOM],
        state: 'new',
        date: '18.04.2025 19:11',
        customer: [
          {
            id: '11',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1701',
            createdDate: '2025-04-18T19:11:10.000Z',
            updatedDate: '2025-04-18T19:11:11.000Z',
            confirmedDate: '2025-04-18T19:06:05.000Z',
            nextUpdateTs: '2025-04-18T19:12:10.000Z',
            blockchain: 'btc',
            asset: null,
            hash: 'e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f',
            direction: 'outcome',
            address: '1gHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmNoPqR',
            flow: 'normal',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '18',
        uid: 'demo-alert-18',
        id: '18',
        user: 'User_3',
        address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
        causingTxHash:
          '0x2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3',
        direction: 'income',
        risk: 'low',
        riskyFunds: 297.52,
        entityCategory: [RiskKeys.DARK_SERVICE],
        state: 'confirmed',
        date: '06.04.2025 16:47',
        customer: [
          {
            id: '12',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1801',
            createdDate: '2025-04-06T16:47:00.000Z',
            updatedDate: '2025-04-06T16:47:01.000Z',
            confirmedDate: '2025-04-06T16:41:55.000Z',
            nextUpdateTs: '2025-04-06T16:48:00.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x4c6e8f0a2c4e6f8a0c2e4f6a8c0e2f4a6c8e0a2c4f6a8c0e2f4a6c8e0a2c4f6',
            direction: 'income',
            address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
            flow: 'slow',
            memo: '',
            level: 'low',
          },
        ] as BehaviorTx[],
      },
      {
        key: '19',
        uid: 'demo-alert-19',
        id: '19',
        user: 'User_3',
        address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
        causingTxHash:
          '0x2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3',
        direction: 'income',
        risk: 'medium',
        riskyFunds: 5955.03,
        entityCategory: [RiskKeys.EXCHANGE_MLRISK_HIGH],
        state: 'confirmed',
        date: '06.04.2025 16:47',
        customer: [
          {
            id: '12',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '1901',
            createdDate: '2025-04-06T16:46:45.000Z',
            updatedDate: '2025-04-06T16:46:46.000Z',
            confirmedDate: '2025-04-06T16:41:40.000Z',
            nextUpdateTs: '2025-04-06T16:47:45.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x5d7f9a1c3e5a7c9e1a3c5e7a9c1e3a5c7e9a1c3e5a7c9e1a3c5e7a9c1e3a5c7',
            direction: 'income',
            address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
            flow: 'fast',
            memo: '',
            level: 'medium',
          },
          {
            id: '1902',
            createdDate: '2025-04-06T16:46:30.000Z',
            updatedDate: '2025-04-06T16:46:31.000Z',
            confirmedDate: '2025-04-06T16:41:25.000Z',
            nextUpdateTs: '2025-04-06T16:47:30.000Z',
            blockchain: 'polygon',
            asset: null,
            hash: '0x6e8f0a2c4e6f8a0c2e4f6a8c0e2f4a6c8e0a2c4f6a8c0e2f4a6c8e0a2c4f6a8',
            direction: 'income',
            address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
            flow: 'normal',
            memo: '',
            level: 'medium',
          },
        ] as BehaviorTx[],
      },
      {
        key: '20',
        uid: 'demo-alert-20',
        id: '20',
        user: 'User_3',
        address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
        causingTxHash:
          '0x2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3',
        direction: 'income',
        risk: 'high',
        riskyFunds: 4168.52,
        entityCategory: [RiskKeys.P2P_EXCHANGE_MLRISK_HIGH],
        state: 'rejected',
        date: '06.04.2025 16:47',
        customer: [
          {
            id: '12',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '2001',
            createdDate: '2025-04-06T16:46:15.000Z',
            updatedDate: '2025-04-06T16:46:16.000Z',
            confirmedDate: '2025-04-06T16:41:10.000Z',
            nextUpdateTs: '2025-04-06T16:47:15.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x7f9a1c3e5a7c9e1a3c5e7a9c1e3a5c7e9a1c3e5a7c9e1a3c5e7a9c1e3a5c7e9',
            direction: 'income',
            address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
            flow: 'fast',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '21',
        uid: 'demo-alert-21',
        id: '21',
        user: 'User_3',
        address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
        causingTxHash:
          '0x2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3',
        direction: 'income',
        risk: 'low',
        riskyFunds: 148.58,
        entityCategory: [RiskKeys.EXCHANGE_FRAUDULENT],
        state: 'confirmed',
        date: '06.04.2025 16:47',
        customer: [
          {
            id: '12',
            name: 'User_3',
            identifier: 'User_3',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '2101',
            createdDate: '2025-04-06T16:46:00.000Z',
            updatedDate: '2025-04-06T16:46:01.000Z',
            confirmedDate: '2025-04-06T16:40:55.000Z',
            nextUpdateTs: '2025-04-06T16:47:00.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x8f0a2c4e6f8a0c2e4f6a8c0e2f4a6c8e0a2c4f6a8c0e2f4a6c8e0a2c4f6a8c0',
            direction: 'income',
            address: '0x6d8c0a9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e',
            flow: 'normal',
            memo: '',
            level: 'low',
          },
        ] as BehaviorTx[],
      },
      {
        key: '22',
        uid: 'demo-alert-22',
        id: '22',
        user: 'User_2',
        address: '1BcDeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmN',
        causingTxHash:
          '3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c',
        direction: 'outcome',
        risk: 'low',
        riskyFunds: 238.22,
        entityCategory: [RiskKeys.TERRORISM_FINANCING],
        state: 'confirmed',
        date: '10.03.2025 14:01',
        customer: [
          {
            id: '12',
            name: 'User_2',
            identifier: 'User_2',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '2201',
            createdDate: '2025-03-10T14:01:30.000Z',
            updatedDate: '2025-03-10T14:01:31.000Z',
            confirmedDate: '2025-03-10T13:56:25.000Z',
            nextUpdateTs: '2025-03-10T14:02:30.000Z',
            blockchain: 'btc',
            asset: null,
            hash: 'f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2c3d4e5f6a',
            direction: 'outcome',
            address: '1BcDeFgHiJkLmNoPqRsTuVwXyZaBcDeFgHiJkLmN',
            flow: 'slow',
            memo: '',
            level: 'low',
          },
        ] as BehaviorTx[],
      },
      {
        key: '23',
        uid: 'demo-alert-23',
        id: '23',
        user: 'User_5',
        address: '0xa9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e6d8c0',
        causingTxHash:
          '0x4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d',
        direction: 'income',
        risk: 'high',
        riskyFunds: 473.62,
        entityCategory: [RiskKeys.SANCTIONS],
        state: 'confirmed',
        date: '02.03.2025 13:56',
        customer: [
          {
            id: '12',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '2301',
            createdDate: '2025-03-02T13:56:15.000Z',
            updatedDate: '2025-03-02T13:56:16.000Z',
            confirmedDate: '2025-03-02T13:51:10.000Z',
            nextUpdateTs: '2025-03-02T13:57:15.000Z',
            blockchain: 'eth',
            asset: null,
            hash: '0x9a1c3e5a7c9e1a3c5e7a9c1e3a5c7e9a1c3e5a7c9e1a3c5e7a9c1e3a5c7e9a1c',
            direction: 'income',
            address: '0xa9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e6d8c0',
            flow: 'fast',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
      {
        key: '24',
        uid: 'demo-alert-24',
        id: '24',
        user: 'User_5',
        address: '0xa9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e6d8c0',
        causingTxHash:
          '0x4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b7c8d9e0f1a2b3c4d',
        direction: 'income',
        risk: 'high',
        riskyFunds: 457.2,
        entityCategory: [RiskKeys.TERRORISM_FINANCING],
        state: 'confirmed',
        date: '02.03.2025 13:56',
        customer: [
          {
            id: '12',
            name: 'User_5',
            identifier: 'User_5',
            level: 'medium',
          },
        ],
        behaviorTxs: [
          {
            id: '2401',
            createdDate: '2025-03-02T13:56:00.000Z',
            updatedDate: '2025-03-02T13:56:01.000Z',
            confirmedDate: '2025-03-02T13:50:55.000Z',
            nextUpdateTs: '2025-03-02T13:57:00.000Z',
            blockchain: 'bsc',
            asset: null,
            hash: '0x0b2d4f6a8c0e2f4a6c8e0a2c4f6a8c0e2f4a6c8e0a2c4f6a8c0e2f4a6c8e0a2',
            direction: 'income',
            address: '0xa9b7e5d3c1f9a7b5c8e0d2a4f6c8b1a2f4e6d8c0',
            flow: 'normal',
            memo: '',
            level: 'high',
          },
        ] as BehaviorTx[],
      },
    ],
    total: 24,
  },
};
